import React from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Grid, Icon, Menu, Tab, TabPane } from 'semantic-ui-react';
import styled from 'styled-components';
import Atributo from './Atributo/Atributo';

// Importar sua action do Redux
import { novoClienteChangeTabAction } from '../../actions/EspacoTecaActions';
import Aplicar from './Aplicar/Aplicar';
import Fabricante from './Fabricante/Fabricante';
import Classificacao from './Classificacao/Classificacao';
import Marca from './Marca/Marca';
import Linha from './Linha/Linha';
import AplicarEst from './AplicarEst/AplicarEst';
import Conteudo from './Conteudo/Conteudo';
import BuscaPorSKU from './BuscaPorSKU/BuscaPorSKU';

function EspacoTeca(props) {
    const { novoClienteChangeTabAction, tabindex } = props;

    const StyledTab = styled(Tab)`
    &&& {
        .ui.tabular.menu .item{
            font-size:10px !important;
            height:10px !important;
        }
        .ui.menu{
            min-height: 0.0em !important;
        }
    }`;

    // Função corrigida sem usar this
    const handleTabChange = (e, { activeIndex }) => {
        novoClienteChangeTabAction(activeIndex);

    };



    let panes = [
        {
            menuItem: <Menu.Item key='TAB1'><Icon name='puzzle piece' />Atributos</Menu.Item>,
            render: () => (
                <TabPane renderActiveOnly={false}>
                    <Atributo />
                </TabPane>
            )
        }
    ];

    panes.push({
        menuItem: <Menu.Item key='TAB2' disabled><Icon name='add' />Aplicar</Menu.Item>,
        render: () => (
            <TabPane>
                <Aplicar />
            </TabPane>
        )
    });

    panes.push({
        menuItem: <Menu.Item key='TAB3' ><Icon name='star' />Classificação</Menu.Item>,
        render: () => (
            <TabPane>
                <Classificacao />
            </TabPane>
        )
    });

    panes.push({
        menuItem: <Menu.Item key='TAB4' ><Icon name='factory' />Fabricante</Menu.Item>,
        render: () => (
            <TabPane>
                <Fabricante />
            </TabPane>
        )
    });

    panes.push({
        menuItem: <Menu.Item key='TAB5' ><Icon name='tag' />Marca</Menu.Item>,
        render: () => (
            <TabPane>
                <Marca />
            </TabPane>
        )
    });

    panes.push({
        menuItem: <Menu.Item key='TAB6' ><Icon name='tags' />Linha</Menu.Item>,
        render: () => (
            <TabPane>
                <Linha />
            </TabPane>
        )
    });

    panes.push({
        menuItem: <Menu.Item key='TAB7' ><Icon name='plus' />Aplicar Estruturação</Menu.Item>,
        render: () => (
            <TabPane>
                <AplicarEst />
            </TabPane>
        )
    });

    panes.push({
        menuItem: <Menu.Item key='TAB8' ><Icon name='content' />Conteúdo</Menu.Item>,
        render: () => (
            <TabPane>
                <Conteudo />
            </TabPane>
        )
    });

    panes.push({
        menuItem: <Menu.Item key='TAB9' ><Icon name='search' />Busca por SKU</Menu.Item>,
        render: () => (
            <TabPane>
                <BuscaPorSKU />
            </TabPane>
        )
    });

    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item>
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Atributos</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>

            <Grid columns={1} doubling>
                <Grid.Column>
                    <StyledTab panes={panes} onTabChange={handleTabChange} activeIndex={tabindex} />
                </Grid.Column>
            </Grid>



                <style>{`

                    /*-------------------------------*/
                    /*Menu Superior*/


                    .ui.mini.menu>.item{
                        padding: 0;
                    }

                    .ui.breadcrumb .section {
                        padding: 1.5em 1.5em !important;
                    }
                    
                    .ui.breadcrumb .section:first-child {
                        padding-right: 0 !important;
                        border-radius: 0 0 0 5px !important;
                    }
                        

                    .ui.breadcrumb .active.section {
                        background-color: #1884af !important;
                        color: #fff !important;
                    }
                `}</style>

        </div>
    );
}

// Conecta ao Redux
const mapStateToProps = (state) => ({
    tabindex: state.EspacoTecaReducer.tabindex,
    userid: state.LoginReducer.userid
});

export default connect(mapStateToProps, {
    novoClienteChangeTabAction
})(EspacoTeca);
